export const WHITELABEL = {
  googleWebClientId: '751547631638-5c11keu0jurcqaobmmoql1vskvi36l25.apps.googleusercontent.com',
  googleIosClientId: '793824503515-j0q7e6cm1kcp2opnlbrn179tbqpi22fo.apps.googleusercontent.com',
};
